/* global $, gsap, ScrollTrigger, Splide */

//---------- BurgerMneu / Dropdown ----------//

$( document ).ready( function() {
	$( '.m_button' ).click( function() {
		$( 'body' ).toggleClass( 'active' );

		$( '.hamBurger-menu' ).toggleClass( 'open-menu' );

		// Add the following lines to prevent body scrolling
		if ( $( 'body' ).hasClass( 'active' ) ) {
			$( 'body' ).css( 'overflow', 'hidden' );
		} else {
			$( 'body' ).css( 'overflow', '' );
		}
	} );
} );
//-------------------tab link active careers page-------------------//

document.addEventListener( 'DOMContentLoaded', function() {
	const tabs = document.querySelectorAll( '.tab-list li' );
	const sections = document.querySelectorAll( '.opportunity-wrap' );

	// Function to show a section
	function showSection( index ) {
		sections.forEach( function( section, idx ) {
			section.style.display = idx === index ? 'block' : 'none';
		} );
	}

	// Initially show the first section
	showSection( 0 );

	tabs.forEach( function( tab, index ) {
		tab.addEventListener( 'click', function() {
			showSection( index );

			tabs.forEach( function( t ) {
				t.classList.remove( 'tab-active' );
			} );

			tab.classList.add( 'tab-active' );
		} );
	} );
} );

//--------------nav-menuitem-active-------------//

document.addEventListener( 'DOMContentLoaded', function() {
	const currentUrl = window.location.href.replace( /\/$/, '' ); // Remove trailing slash from current URL

	const navLinks = document.querySelectorAll( '.nav-menu-active a' );

	navLinks.forEach( function( link ) {
		const href = link.href.replace( /\/$/, '' ); // Remove trailing slash from link href

		if ( href === currentUrl ) {
			link.parentElement.classList.add( 'nav-active' ); // Adding active class to parent li
		}
	} );
} );

//----------------what we do page anumation-----------------//

// Function to handle intersection changes
function handleIntersection( entries, observer ) {
	entries.forEach( ( entry ) => {
		if ( entry.isIntersecting ) {
			// Add your animation class here
			entry.target.classList.add( 'active' );

			// Once animation is applied, you may want to disconnect the observer
			observer.unobserve( entry.target );
		}
	} );
}
// Create a new intersection observer
const observer = new IntersectionObserver( handleIntersection, {
	root: null, // viewport
	rootMargin: '0px', // no margin
	threshold: 0.5, // 50% of the element visible
} );

// Select the elements you want to observe
const elementsToObserve = document.querySelectorAll( '.svganimate' );

// Start observing each element
elementsToObserve.forEach( ( element ) => {
	observer.observe( element );
} );

//----------contactfrom label moving upward-------//
$( document ).ready( function() {
	$( '.text-field-input' ).on( 'focus', function() {
		$( this ).closest( '.field-wrapper' ).addClass( 'focused' );
	} );

	$( '.text-field-input' ).on( 'blur', function() {
		if ( $( this ).val() === '' ) {
			$( this ).closest( '.field-wrapper' ).removeClass( 'focused' );
		}
	} );
} );

//--------------contactform error style for input--------------//

document.addEventListener( 'DOMContentLoaded', function() {
	document.addEventListener(
		'wpcf7invalid',
		function( event ) {
			// Check if invalidFields is defined and is an array
			const invalidFields =
        event.detail.apiResponse && event.detail.apiResponse.invalidFields;

			if ( Array.isArray( invalidFields ) ) {
				invalidFields.forEach( function( field ) {
					const inputElement = document.querySelector(
						`[name="${ field.into.replace( /^\./, '' ) }"]`
					);
					if ( inputElement ) {
						inputElement.classList.add( 'wpcf7-not-valid' );
					}
				} );
			}
		},
		false
	);
} );

//gsap
document.addEventListener( 'DOMContentLoaded', function() {
	// const textElement = document.querySelector('.content-clr-transition');
	// const words = textElement.innerText.split(' ');
	// let currentIndex = 0;
	const growthContainer = document.querySelector( '.growth-bp-container' );
	if ( growthContainer ) {
		gsap.registerPlugin( ScrollTrigger );

		// Pin the growth-bp-container
		gsap.to( '.growth-bp-container', {
			scrollTrigger: {
				trigger: '.growth-bp-container',
				start: 'center center',
				end: '+=150%',
				pin: true,
				scrub: true,
			},
		} );
	}
	// Animate text color transition on scroll
	// ScrollTrigger.create({
	//   trigger: textElement,
	//   start: "top center",
	//   end: "+=55%",
	//   onUpdate: self => {
	//     const progress = self.progress;
	//     const totalWords = words.length;
	//     const wordsPerStep = 5;
	//     const newIndex = Math.floor(progress * totalWords / wordsPerStep) * wordsPerStep;

	//     if (newIndex !== currentIndex) {
	//       currentIndex = newIndex;
	//       textElement.innerHTML = words.map((word, index) => {
	//         if (index >= currentIndex && index < currentIndex + wordsPerStep) {
	//           return `<span class="word-active">${word}</span>`;
	//         } else {
	//           return word;
	//         }
	//       }).join(' ');
	//     }
	//   }
	// });

	// Responsive animations for growth-item-content
	const GrowthItemcontent = document.querySelector( '.growth-item-content' );
	if ( GrowthItemcontent ) {
		const mm = gsap.matchMedia();

		gsap.to( '.growth-item-content', {
			y: '-50%', // Move upwards to its final position
			scrollTrigger: {
				trigger: '.growth-bp-container',
				start: 'center center',
				end: '+=150%',
				scrub: true,
			},
		} );

		mm.add( '(max-width:1199px)', function() {
			gsap.to( '.growth-item-content-div', {
				y: '-0%', // Move downwards for small screens
				scrollTrigger: {
					trigger: '.growth-bp-container',
					start: 'center center',
					end: '+=150%',
					scrub: true,
				},
			} );
		} );

		mm.add( '(max-width: 474px)', function() {
			gsap.to( '.growth-item-content', {
				y: '-50%', // Move downwards for small screens
				scrollTrigger: {
					trigger: '.growth-bp-container',
					start: 'center center',
					end: '+=200%',
					scrub: true,
				},
			} );
		} );
	}
	const moveLeft = document.querySelector( '.move-left' );
	const moveRight = document.querySelector( '.move-right' );
	const moveDownGrp = document.querySelector( '.move-down-grp' );
	const animationSvgHeading = document.querySelector( '.animation-svg-heading' );

	// Create a timeline for the sequence
	if ( moveLeft && moveRight && moveDownGrp && animationSvgHeading ) {
		const tl = gsap.timeline( {
			scrollTrigger: {
				trigger: '.growth-item-content',
				start: 'center center',
				end: '+=150%',
				scrub: 1,
			},
		} );

		// Move .move-left left and down, .move-right right and down, and .move-down-grp right simultaneously
		tl.to( [ '.move-left', '.move-right', '.move-down-grp' ], {
			x: ( i, target ) => {
				if ( target.classList.contains( 'move-left' ) ) {
					return -18;
				} else if ( target.classList.contains( 'move-right' ) ) {
					return 64;
				} else if ( target.classList.contains( 'move-down-grp' ) ) {
					return 20; // Adjust the value to move right slightly
				}
				return 0;
			},
			y: ( i, target ) =>
				target.classList.contains( 'move-left' ) ||
        target.classList.contains( 'move-right' )
					? 26
					: 6, // Move down slightly for .move-left and .move-right
			duration: 7, // Adjust the duration as needed
		} );

		// Move all three elements down simultaneously and show .animation-svg-heading
		tl.to( [ '.move-left', '.move-right', '.move-down-grp' ], {
			y: '+=154',
			duration: 7, // Adjust the duration as needed
			delay: 5,
		} ).to(
			'.animation-svg-heading',
			{
				opacity: 1,
				duration: 2,
			},
			'<'
		); // Use "<" to start this animation at the same time as the previous one

		// Rotate the specified elements in the SVG groups after move-down-grp animation completes
		tl.to( '.enterprise-grp .rotate-target, .business-grp .rotate-target', {
			rotation: 180, // Rotate right
			transformOrigin: 'center center',
			duration: 30,
			ease: 'power2.out', // Optional easing function
		} ).to(
			'.strategic-grp .rotate-target',
			{
				rotation: -180,
				transformOrigin: 'center center',
				duration: 30,
				ease: 'power2.out',
			},
			'<'
		);
		tl.to(
			'.main-circle-grp .rotate-target',
			{
				rotation: 108,
				transformOrigin: 'center center',
				duration: 30,
				ease: 'power2.out',
			},
			'<'
		);
	}
} );

//--------------------------------------tab--------------------------------------//
document.addEventListener( 'DOMContentLoaded', function() {
	const tabWrappers = document.querySelectorAll( '.tab-wrapper' );

	if ( tabWrappers !== null ) {
		tabWrappers.forEach( function( tabWrapper ) {
			const tabBlocks = tabWrapper.querySelectorAll( '.tab-block' );

			if ( tabBlocks !== null ) {
				tabBlocks.forEach( function( tabBlock ) {
					const tabMnu = tabBlock.querySelectorAll( '.tab-menu li' );
					const tabContent = tabBlock.querySelectorAll(
						'.tab-content > .tab-items'
					);

					tabContent.forEach( function( content, i ) {
						if ( i !== 0 ) {
							content.style.display = 'none';
						}
					} );

					tabMnu.forEach( function( menu, i ) {
						if ( tabContent[ i ] ) {
							// Ensure tabContent[i] exists
							menu.setAttribute( 'data-tab', 'tab' + i );
							tabContent[ i ].setAttribute( 'data-tab', 'tab' + i );
						}
					} );

					tabMnu.forEach( function( menu ) {
						menu.addEventListener( 'click', function() {
							const tabData = this.getAttribute( 'data-tab' );

							tabContent.forEach( function( content ) {
								content.style.display = 'none';
							} );

							const tabItem = tabBlock.querySelector(
								'.tab-content > .tab-items[data-tab=' + tabData + ']'
							);
							if ( tabItem !== null ) {
								tabItem.style.display = 'block';
							}

							const activeTab = tabBlock.querySelector( '.tab-menu li.tab-active' );
							if ( activeTab !== null ) {
								activeTab.classList.remove( 'tab-active' );
							}
							this.classList.add( 'tab-active' );
						} );
					} );
				} );
			}
		} );
	}
} );


//---------- Stciky Header ----------//
document.addEventListener( 'DOMContentLoaded', () => {
	// (1) Sticky Header
	let didScroll;
	let lastScrollTop = 0;
	const delta = 4;
	const navbarHeight = $( '.site-header' ).outerHeight();

	$( window ).on( 'scroll', function() {
		didScroll = true;
	} );

	setInterval( function() {
		if ( didScroll ) {
			hasScrolled();
			didScroll = false;
		}
	}, 250 );

	function hasScrolled() {
		const st = $( window ).scrollTop();
		if ( Math.abs( lastScrollTop - st ) <= delta ) {
			return;
		}
		if ( st > lastScrollTop && st > navbarHeight ) {
			// Scroll Down
			$( '.site-header' ).removeClass( 'nav-down' ).addClass( 'nav-up' );
		} else if ( st + $( window ).height() < $( document ).height() && st > navbarHeight ) {
			// Scroll Up
			$( '.site-header' ).removeClass( 'nav-up' ).addClass( 'nav-down' );
		}
		if ( st >= 200 ) {
			$( '.site-header' ).addClass( 'nav-hiding' );
		} else {
			$( '.site-header' ).removeClass( 'nav-hiding' );
		}
		if ( st < delta ) {
			$( '.site-header' ).removeClass( 'nav-up nav-down' );
		}
		lastScrollTop = st;
	}
} );

// smoth scroll for what we do
window.scrollToSection = function( event, sectionID ) {
	event.preventDefault();
	const section = document.getElementById( sectionID );
	if ( section ) {
		section.scrollIntoView( { behavior: 'smooth' } );
	}
};

// careers
// accordion
const accordions = document.querySelectorAll( '.accordion__item--header' );
if ( accordions !== null ) {
	accordions.forEach( ( header ) => {
		header.addEventListener( 'click', () => {
			const accordionItem = header.closest( '.accordion__item' );
			const accordionContent = accordionItem.querySelector(
				'.accordion__item--content'
			);
			// Collapse previously opened items
			document.querySelectorAll( '.accordion__item' ).forEach( ( item ) => {
				if ( item !== accordionItem && item.classList.contains( 'active' ) ) {
					item.classList.remove( 'active' );
					item.querySelector( '.accordion__item--content' ).style.maxHeight = 0;
				}
			} );

			// Expand or collapse the current item
			if ( accordionItem.classList.contains( 'active' ) ) {
				accordionItem.classList.remove( 'active' );
				accordionContent.style.maxHeight = 0;
			} else {
				accordionItem.classList.add( 'active' );
				if ( window.innerWidth <= 768 ) {
					accordionContent.style.maxHeight = '100%';
				} else {
					accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
				}

				// Ensure the active item is scrolled into view with padding
				setTimeout( () => {
					// Get the position of the accordion item
					const itemRect = accordionItem.getBoundingClientRect();

					// Calculate the desired scroll position with padding
					const padding = 100; // Adjust the padding value as needed
					const scrollY = window.scrollY;
					const topPosition = itemRect.top + scrollY - padding;

					window.scrollTo( {
						top: topPosition,
						behavior: 'smooth',
					} );
				}, 300 ); // Adjust the delay if needed to match the animation duration
			}
		} );
	} );
}

document.addEventListener('DOMContentLoaded', function() {
  const splideElement = document.querySelector('#careers-slider');
  if (splideElement) {
    new Splide('#careers-slider', {
      type      : 'loop',
      perPage   : 3,
      autoplay  : true,
      interval  : 2000,
      pagination: false,
      arrows    : true,
      drag      : true,
      gap       : '20px',
      padding   : '10%',
      throttle  : 300,
      breakpoints: {
        1440: {
          perPage : 1,
          padding : '30%',
        },
        768: {
          perPage : 1,
          padding : '10%',
        },
      },
    }).mount();
  }
});

// // homepage journy section

document.addEventListener( 'DOMContentLoaded', function() {
	gsap.registerPlugin( ScrollTrigger );

	if ( document.querySelector( '.journey-section' ) ) {
		const spantexts = document.querySelectorAll( '.animate-span' );

		// Fetch the dynamic text from the specified HTML element
		const defaulttextone = document
			.querySelector( '.default_text_one' )
			.textContent.trim();
		const defaulttexttwo = document
			.querySelector( '.default_text_two' )
			.textContent.trim();
		const spanoneright = document
			.querySelector( '.span-one-right' )
			.textContent.trim();
		const spanoneleft = document
			.querySelector( '.span-one-left' )
			.textContent.trim();

		const spantworight = document
			.querySelector( '.span-two-right' )
			.textContent.trim();
		const spantwoleft = document
			.querySelector( '.span-two-left' )
			.textContent.trim();

		// Define the sequence of text changes using dynamic text
		const textChanges = [
			[
				{ from: defaulttextone, to: spanoneleft },
				{ from: spanoneleft, to: spantwoleft },
			],
			[
				{ from: defaulttexttwo, to: spanoneright },
				{ from: spanoneright, to: spantworight }, // Use dynamic text here
			],
		];

		// Function to handle text change on completion
		function changeText( span, change ) {
			// Replace all occurrences of `change.from` with `change.to`
			const regex = new RegExp( change.from, 'g' );
			span.textContent = span.textContent.replace( regex, change.to );
		}

		// Function to reset the span to its initial state
		function resetSpan( span, initialText ) {
			span.textContent = initialText; // Reset text content
			gsap.set( span, { width: 'auto', display: 'inline-block' } );
		}

		// Iterate over each span element
		spantexts.forEach( ( span, index ) => {
			// Check if `index` is valid
			if ( index >= textChanges.length ) {
				// eslint-disable-next-line no-console
				console.warn( `No text changes defined for span index ${ index }` );
				return;
			}

			const changes = textChanges[ index ];
			const initialText = span.textContent; // Store initial text content

			// Create GSAP timeline for each span
			const timeline = gsap.timeline( {
				scrollTrigger: {
					trigger: span,
					start: 'top 80%',
					end: 'top 20%',
					toggleActions: 'play none none none',
					onEnter: () => {
						// Restart animation from the beginning
						resetSpan( span, initialText );
						timeline.restart( true ); // Restart timeline from the beginning
					},
					onLeaveBack: () => {
						// Optionally, reset the animation if leaving backward
						resetSpan( span, initialText );
					},
				},
			} );

			changes.forEach( ( change ) => {
				timeline
					.to( span, {
						duration: 1,
						width: 0, // Shrink width to 0
						ease: 'power1.inOut',
						overflow: 'hidden',
						delay: 2,
						onComplete: () => changeText( span, change ),
					} )
					.to( span, {
						duration: 1,
						width: 'auto', // Expand width to auto
						ease: 'power1.inOut',
						display: 'inline-block', // Ensure inline-block for smooth transition
					} );
			} );
		} );
	}
} );

// shre blog post on social platforms

document.addEventListener( 'DOMContentLoaded', function() {
	window.handleshare = ( data ) => {
		const LinkedInlink = 'https://www.linkedin.com/sharing/share-offsite/?url=';
		const Twitterlink = 'https://twitter.com/intent/tweet?url=';
		if ( data === 'linkedIn' ) {
			window.open( LinkedInlink + window.location.href, '_blank' );
		}
		if ( data === 'twitter' ) {
			window.open( Twitterlink + window.location.href, '_blank' );
		}
	};

	// homepage testimonial slider
	const splideElement = document.querySelector( '#hm-testimonial-splide' );

	if ( splideElement ) {
		new Splide( '#hm-testimonial-splide', {
			type: 'loop',
			focus: 'center',
			autoplay: true,
			interval: 3000,
			pagination: true,
			arrows: true,
			drag: true,
			throttle: 300,
			speed: 600,
			pauseOnHover: true,
			perPage: 1,
			gap: '20px',
			padding: '20%',

			breakpoints: {
				768: {
					perPage: 1,
					padding: '0', // remove side padding on mobile
					focus: 0,
					arrows: false,
				},
			},

		} ).mount();
	}

	// hm partners section slider
	const splidePartners = document.querySelector( '#partnersSlider' );
	if ( ! splidePartners ) {
		return;
	}

	const splide = new Splide( '#partnersSlider', {
		type: 'loop',
		perPage: 1,
		focus: 'center',
		autoplay: false,
		pagination: false,
		arrows: true,
		drag: true,
		speed: 500,
		gap: '20px',
		breakpoints: {
			768: {
				perPage: 1,
				padding: '0', // remove side padding on mobile
				focus: 0,
				arrows: false,
				gap: '15px',
			},
		},
	} ).mount();

	// const logoItems = document.querySelectorAll(".logo-item");

	// Sync logo active state when slider moves
	splide.on( 'moved', function( newIndex ) {
		// logoItems.forEach(item => item.classList.remove("active"));
		// Find logo matching the current slide index
		const activeItem = document.querySelector( `.logo-item[data-index="${ newIndex }"]` );
		if ( activeItem ) {
			activeItem.classList.add( 'active' );
		}
	} );

	// Click logo → go to that slide
	// logoItems.forEach(function (item) {
	//   item.addEventListener("click", function () {
	//     const index = parseInt(this.dataset.index);
	//     splide.go(index);
	//     logoItems.forEach(i => i.classList.remove("active"));
	//     this.classList.add("active");
	//   });
	// });
} );

document.addEventListener( 'DOMContentLoaded', function() {
	const tabBtns = document.querySelectorAll( '.tab-btn' );
	const tabPanels = document.querySelectorAll( '.tab-panel' );

	tabBtns.forEach( function( btn ) {
		btn.addEventListener( 'click', function() {
			const target = this.dataset.tab;

			// Update buttons
			tabBtns.forEach( ( b ) => b.classList.remove( 'active' ) );
			this.classList.add( 'active' );

			// Update panels
			tabPanels.forEach( ( p ) => p.classList.remove( 'active' ) );
			document.querySelector( `.tab-panel[data-panel="${ target }"]` ).classList.add( 'active' );
		} );
	} );
} );
// platform single page
document.addEventListener( 'DOMContentLoaded', function() {
	const tabBtns = document.querySelectorAll( '.partner-tab-btn' );
	const tabPanels = document.querySelectorAll( '.partner-tab-panel' );

	tabBtns.forEach( function( btn ) {
		btn.addEventListener( 'click', function() {
			const target = this.dataset.tab;

			// Remove active classes
			tabBtns.forEach( ( b ) => b.classList.remove( 'active' ) );
			tabPanels.forEach( ( panel ) => panel.classList.remove( 'active' ) );

			// Add active to clicked tab
			this.classList.add( 'active' );

			// Find matching panel
			const activePanel = document.querySelector(
				`.partner-tab-panel[data-panel="${ target }"]`
			);

			// Activate panel if exists
			if ( activePanel ) {
				activePanel.classList.add( 'active' );
			}
		} );
	} );
} );

document.addEventListener( 'DOMContentLoaded', function() {
	const items = document.querySelectorAll( '.accordion-item' );
	let current = 0;

	function activate( index ) {
		items.forEach( ( item, i ) => {
			item.classList.toggle( 'active', i === index );
		} );

		current = index;
	}

	items.forEach( ( item, i ) => {
		item.addEventListener( 'click', () => {
			if ( i === current ) {
				return;
			}
			activate( i );
		} );
	} );

	activate( 0 );
} );

//  homepage arrow animation

document.addEventListener( 'DOMContentLoaded', () => {
	const section = document.querySelector( '.card-wrap' );
	const arrow = document.querySelector( '.arrow' );

	if ( ! section ) {
		return;
	}

	const cards = section.querySelectorAll( '.way-card' );

	const cardObserver = new IntersectionObserver( ( entries ) => {
		entries.forEach( ( entry ) => {
			if ( entry.isIntersecting ) {
				// cards animate in
				cards.forEach( ( card, i ) => {
					setTimeout( () => {
						card.classList.add( 'way-card--visible' );
					}, i * 200 );
				} );

				// arrow grows after cards finish
				setTimeout( () => {
					if ( arrow ) {
						arrow.classList.add( 'arrow--visible' );
					}
				}, ( cards.length * 150 ) + 400 );

				cardObserver.unobserve( section );
			}
		} );
	}, { rootMargin: '0px 0px -40% 0px', threshold: 0 } );

	cardObserver.observe( section );
} );

// homepage logo marquee
document.addEventListener( 'DOMContentLoaded', function() {
	const track = document.querySelector( '.logo-track' );

	if ( ! track ) {
		return;
	}

	const originalContent = track.innerHTML;

	// Add 2 more copies = 3 total
	track.innerHTML += originalContent;
	track.innerHTML += originalContent;
} );

document.addEventListener('DOMContentLoaded', () => {
	const track = document.querySelector('.marquee-track');
	if (!track) return;
  
	const items = track.querySelector('.marquee-items');
	if (!items) return;
  
	// Clone and append a second copy
	const clone = items.cloneNode(true);
	track.appendChild(clone);
  });

document.addEventListener( 'DOMContentLoaded', function() {
	const dropdownParents = document.querySelectorAll( '.has-dropdown > .menu-link' );

	dropdownParents.forEach( function( link ) {
		link.addEventListener( 'click', function( e ) {
			const parent = this.parentElement;

			// close if already open

			if ( parent.classList.contains( 'active-dropdown' ) ) {
				parent.classList.remove( 'active-dropdown' );

				return;
			}

			// stop navigation first click

			e.preventDefault();

			// close other dropdowns

			document.querySelectorAll( '.has-dropdown' ).forEach( function( item ) {
				item.classList.remove( 'active-dropdown' );
			} );

			// open current dropdown

			parent.classList.add( 'active-dropdown' );
		} );
	} );

	// close on outside click

	document.addEventListener( 'click', function( e ) {
		if ( ! e.target.closest( '.has-dropdown' ) ) {
			document.querySelectorAll( '.has-dropdown' ).forEach( function( item ) {
				item.classList.remove( 'active-dropdown' );
			} );
		}
	} );
} );







document.addEventListener('DOMContentLoaded', () => {
    const slides = document.querySelectorAll('.hero-title .title-hm-wrap');

    if (!slides.length) return;

    let currentIndex = 0;
    let isAnimating = false;

    // ── Format desc text based on screen size ──────────────────────────────
    function formatDescText(slide) {
        const desc = slide.querySelector('.hero-desc');
        if (!desc) return;

        if (!desc.dataset.originalText) {
            desc.dataset.originalText = desc.textContent.trim();
        }

        const words        = desc.dataset.originalText.split(' ');
        const isMobile     = window.innerWidth < 768;
        const wordsPerLine = isMobile ? 3 : 8;

        const lines = [];
        for (let i = 0; i < words.length; i += wordsPerLine) {
            lines.push(words.slice(i, i + wordsPerLine).join(' '));
        }

        desc.innerHTML = lines.join('<br>');
    }

    // ── Init clip styles for a slide ───────────────────────────────────────
    function initSlide(slide) {
        const titleClip = slide.querySelector('.hero-title-clip');
        const descClip  = slide.querySelector('.hero-desc-clip');

        [titleClip, descClip].forEach(el => {
            el.style.display    = 'block';
            el.style.overflow   = 'hidden';
            el.style.whiteSpace = 'nowrap';
            el.style.transition = 'none';
            el.style.width      = '0px';
        });
    }

    // ── Measure widths accurately ──────────────────────────────────────────
    function measureWidths(slide) {
        const titleInner = slide.querySelector('.hero-title-rotate');
        const descClip   = slide.querySelector('.hero-desc-clip');
        const descInner  = slide.querySelector('.hero-desc');

        // Temporarily expose to measure
        descClip.style.width      = 'max-content';
        descInner.style.display   = 'inline-block';
        descInner.style.whiteSpace = 'nowrap';

        const titleW = Math.ceil(titleInner.scrollWidth);
        const descW  = Math.ceil(descInner.offsetWidth);

        // Reset back
        descClip.style.width    = '0px';
        descInner.style.display = '';

        return { titleW, descW };
    }

    // ── Animate slide in ───────────────────────────────────────────────────
    function animateIn(slide, done) {
        const titleClip = slide.querySelector('.hero-title-clip');
        const descClip  = slide.querySelector('.hero-desc-clip');

        const { titleW, descW } = measureWidths(slide);

        slide.classList.add('active');

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {

                // 1. Animate title in
                titleClip.style.height     = 'auto';
                titleClip.style.transition = 'width 0.9s ease';
                titleClip.style.width      = titleW + 'px';

                // 2. Animate desc in after title
                setTimeout(() => {
                    descClip.style.transition = 'width 0.9s ease';
                    descClip.style.width      = descW + 'px';
                }, 1200);

                if (done) setTimeout(done, 1800);
            });
        });
    }

    // ── Animate slide out ──────────────────────────────────────────────────
    function animateOut(slide, done) {
        const titleClip = slide.querySelector('.hero-title-clip');
        const descClip  = slide.querySelector('.hero-desc-clip');

        // 1. Collapse desc first
        descClip.style.transition = 'width 0.5s ease';
        descClip.style.width      = '0px';

        // 2. Then collapse title
        setTimeout(() => {
            titleClip.style.transition = 'width 0.5s ease';
            titleClip.style.width      = '0px';
        }, 150);

        // 3. Clean up after animation
        setTimeout(() => {
            titleClip.style.height = '0px';
            slide.classList.remove('active');
            if (done) done();
        }, 150 + 500 + 50);
    }

    // ── Cycle to next slide ────────────────────────────────────────────────
    function next() {
        if (isAnimating) return;
        isAnimating = true;

        animateOut(slides[currentIndex], () => {
            currentIndex = (currentIndex + 1) % slides.length;
            animateIn(slides[currentIndex], () => {
                setTimeout(() => {
                    isAnimating = false;
                    next();
                }, 2000);
            });
        });
    }

    // ── Handle resize — reformat text & re-measure ────────────────────────
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            slides.forEach(slide => formatDescText(slide));
        }, 150);
    });

    // ── Boot ───────────────────────────────────────────────────────────────
    slides.forEach(slide => {
        formatDescText(slide); // format text first
        initSlide(slide);      // then init clip styles
    });

    animateIn(slides[0], () => {
        setTimeout(next, 2000);
    });
});

//arcai platform section animation
document.addEventListener( 'DOMContentLoaded', () => {
	// disable on tablet/mobile
	if ( window.innerWidth <= 1024 ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const scrollWrap = document.querySelector( '.platform-scroll-wrap' );
	const video = document.querySelector( '.platform-ways-video' );

	if ( ! scrollWrap || ! video ) {
		return;
	}

	ScrollTrigger.create( {
		trigger: scrollWrap,
		start: 'top top',
		end: 'bottom +=90%',
		pin: '.platform-ways-video',
		pinSpacing: false,
	} );
} );

const tabs = document.querySelectorAll('.tab-menu li');
const careers = document.getElementById('careers-section');

tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
        if (tab.classList.contains('podcast-tab')) {
            careers.style.display = 'none';
        } else {
            careers.style.display = '';
        }
    });
});
document.addEventListener('DOMContentLoaded', function () {
    const readMore = document.querySelector('.podcast-read-more');
    const readLess = document.querySelector('.podcast-read-less');
    const shortContent = document.querySelector('.podcast-short-content');
    const fullContent = document.querySelector('.podcast-full-content');

    if (readMore) {
        readMore.addEventListener('click', function (e) {
            e.preventDefault();

            shortContent.classList.add('hide');
            fullContent.classList.add('active');
        });
    }

    if (readLess) {
        readLess.addEventListener('click', function (e) {
            e.preventDefault();

            fullContent.classList.remove('active');
            shortContent.classList.remove('hide');
        });
    }
});
document.addEventListener('DOMContentLoaded', function () {
    const triggers = document.querySelectorAll('.podcast-video-trigger');
    const modal = document.querySelector('.podcast-video-modal');
    const closeBtn = document.querySelector('.podcast-video-close');
    const iframe = document.getElementById('podcast-video-frame');

    // Stop if required elements don't exist
    if (!modal || !iframe || !closeBtn || !triggers.length) {
        return;
    }

    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();

            let url = this.dataset.video;

            if (!url) {
                return;
            }

            // Standard YouTube URL
            if (url.includes('watch?v=')) {
                url = url.replace('watch?v=', 'embed/');
            }

            // Short YouTube URL
            if (url.includes('youtu.be/')) {
                const videoId = url.split('youtu.be/')[1];
                url = 'https://www.youtube.com/embed/' + videoId;
            }

            iframe.src = url + '?autoplay=1';
            modal.classList.add('active');
            document.body.classList.add('modal-open');
        });
    });

    function closeModal() {
        modal.classList.remove('active');
        iframe.src = '';
        document.body.classList.remove('modal-open');
    }

    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function (e) {
        if (e.target === modal) {
            closeModal();
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeModal();
        }
    });
});
document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.newsroom-tabs li');
    const sections = document.querySelectorAll('.newsroom-section');

    tabs.forEach(tab => {
        tab.addEventListener('click', function () {
            tabs.forEach(t => t.classList.remove('active'));
            this.classList.add('active');

            const filter = this.dataset.filter;

            sections.forEach(section => {
                if (
                    filter === 'all' ||
                    section.classList.contains(filter)
                ) {
                    section.style.display = '';
                } else {
                    section.style.display = 'none';
                }
            });
        });
    });
});